module.exports = __webpack_public_path__ + "static/media/common_all_users.9ef377ff.png";